import { APP_MODE } from "@/data/constants";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

const INITIAL_STATE: TState = {
  saleMode: "NONE",
  noSaleModeBanner: false,
  skipPromoCodeOnUpgrade: false,
  saleBanners: {},
  saleRestriction: undefined,
  skipPromoCodeOnIntervalChange: false,
};

type TState = {
  saleMode: APP_MODE | "NONE";
  noSaleModeBanner: boolean;
  skipPromoCodeOnUpgrade: boolean;
  skipPromoCodeOnIntervalChange: boolean; // only from monthly to yearly

  saleBanners?: {
    pricingBanner?: JSX.Element | null;
    reviewBanner?: JSX.Element | null;
    promotionBanner?: JSX.Element | null;
  };

  saleRestriction?: {
    onlyUpgrade: boolean;
    onlyYearlyPlan: boolean;
  };
};

type TActions = {
  setNoSaleModeBanner: (state: boolean) => void;
  setSkipPromoCodeOnUpgrade: (state: boolean) => void;
  setSkipPromoCodeOnIntervalChange: (state: boolean) => void;
  setSaleMode: (newMode: APP_MODE | "NONE") => void;

  setSaleBanners: (
    banners:
      | {
          pricingBanner?: JSX.Element | null;
          reviewBanner?: JSX.Element | null;
          promotionBanner?: JSX.Element | null;
        }
      | undefined,
  ) => void;

  setSaleRestriction: (restriction?: {
    onlyUpgrade: boolean;
    onlyYearlyPlan: boolean;
  }) => void;

  reset: () => void;
};

type T = TState & TActions;

const useSaleModeStore = create<T>()(
  devtools((set) => ({
    saleBanners: {},
    setSaleBanners: (banners) => set({ saleBanners: banners }),

    noSaleModeBanner: false,
    setNoSaleModeBanner: (state) => set({ noSaleModeBanner: state }),

    skipPromoCodeOnUpgrade: false,
    setSkipPromoCodeOnUpgrade: (state) =>
      set({ skipPromoCodeOnUpgrade: state }),

    skipPromoCodeOnIntervalChange: false,
    setSkipPromoCodeOnIntervalChange: (state) =>
      set({ skipPromoCodeOnIntervalChange: state }),

    saleMode: "NONE",
    setSaleMode: (newMode) => set({ saleMode: newMode }),

    saleRestriction: undefined,
    setSaleRestriction: (restriction) =>
      set({
        saleRestriction: restriction,
      }),

    reset: () => set(INITIAL_STATE),
  })),
);

export default useSaleModeStore;
